import { Mail, Map, PhoneCall } from "lucide-react";
import { FaAward, FaMapMarkerAlt, FaUsers } from "react-icons/fa";

export const stats = [
  {
    number: 5,
    suffix: "+",
    label: "Years of Excellence",
    description:
      "Over a decade of delivering top-notch customized solutions across India.",
    icon: FaAward,
    color: "from-purple-400 to-purple-600",
    delay: 0.1,
  },
  {
    number: 700,
    suffix: "+",
    label: "Clients Trusted",
    description:
      "Trusted by businesses nationwide for quality and reliability.",
    icon: FaUsers,
    color: "from-blue-400 to-blue-600",
    delay: 0.2,
  },
  {
    number: "PAN",
    label: "India Presence",
    description:
      "We bring personalized branding solutions to every corner of India.",
    icon: FaMapMarkerAlt,
    color: "from-rose-400 to-rose-600",
    delay: 0.3,
  },
];

export const contactInfo = [
  {
    id: 1,
    icon: PhoneCall,
    title: "Call Us",
    description: "Speak directly with our team for immediate assistance.",
    info: "+91 8637758689\nMon-Fri, 9:30 AM - 6:30 PM IST",
  },
  {
    id: 2,
    icon: Mail,
    title: "Email Us",
    description: "Send us your enquiry, and we'll respond within 24 hours.",
    info: "sales@360customizer.com",
  },
  {
    id: 3,
    icon: Map,
    title: "Visit Us",
    description:
      "Come to our office for a personal consultation and see our work firsthand.",
    info: "360 Customizer, Pune, M.H., India",
  },
];

export const iconBgVariants = [
  "from-blue-500 to-blue-700",
  "from-purple-500 to-purple-700",
  "from-indigo-500 to-indigo-700",
];
